module.exports = __webpack_public_path__ + "static/media/main.223a85f2.png";